import React from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { gaEvent } from '../../../common/services/analytics'
import {
  EmarModuleCard,
  FamilyPlanModuleCard,
  ProModuleCard,
} from '@lmc/ui-kit'
import { Link } from 'react-router-dom'
import Card from './Card'

const triggerGAEvent = (label: string) =>
  gaEvent({
    category: 'home-dashboard',
    action: 'advert click',
    label,
  })

type AdvertProps = {
  children?: React.ReactNode
  containerStyle?: React.CSSProperties
  img?: string
  onClick?: () => void
  target?: string
  type?: 'Pro' | 'eMAR' | 'Family'
  url?: string
}

const Advert = ({
  containerStyle = styles.container,
  img,
  type,
  url,
  ...props
}: AdvertProps) => {
  switch (type) {
    case 'Pro':
      return (
        <div className="lmc-card" style={containerStyle}>
          <ProModuleCard onClick={() => triggerGAEvent('pro')} />
        </div>
      )
    case 'eMAR':
      return (
        <div className="lmc-card" style={containerStyle}>
          <EmarModuleCard onClick={() => triggerGAEvent('emar')} />
        </div>
      )
    case 'Family':
      return (
        <div className="lmc-card" style={containerStyle}>
          <FamilyPlanModuleCard onClick={() => triggerGAEvent('family')} />
        </div>
      )
    default:
      return null
  }
}

interface Props {
  familyModuleEnabled: boolean
  hasFamily: boolean
  hasPro: boolean
  hasEmar: boolean
  userFirstLogin: string
}

export const AdvertCard = ({
  familyModuleEnabled,
  hasEmar,
  hasFamily,
  hasPro,
}: Props): React.ReactElement | null => {
  const showFamilyAdvert = familyModuleEnabled && !hasFamily

  const renderAdvert = (): React.ReactElement | null => {
    if (!hasPro) return <Advert type="Pro" />
    if (!hasEmar) return <Advert type="eMAR" />
    if (showFamilyAdvert) return <Advert type="Family" />

    return null
  }

  return (
    <Card>
      <div id="intro-js-step-advert" style={{ marginTop: 18 }}  data-cy="advert-card">
        {renderAdvert()}
      </div>
    </Card>
  )
}

const styles = {
  container: {
    borderRadius: 25,
    display: 'block',
    height: 280,
    overflow: 'hidden',
    padding: 0,
  },
  centerContainer: {
    display: 'block',
    textAlign: 'center' as const,
    overflow: 'hidden',
    height: 273,
    padding: 0,
  },
  image: {
    height: '100%',
  },
}

const mapStateToProps = (state: any) => ({
  familyModuleEnabled: get(state, 'global.home.family') || false,
  hasCarePlans: get(state, 'global.home.carePlans') || false,
  hasFamily: get(state, 'global.home.familySetupComplete') || false,
  hasPro: get(state, 'global.home.pro') || false,
  hasEmar: get(state, 'global.home.eMAR') || false,
  userFirstLogin: get(state, 'global.user.firstLogin') || false,
})

export default connect(mapStateToProps)(AdvertCard)
